import { render, staticRenderFns } from "./ProjectTree.vue?vue&type=template&id=fa4f2b68&scoped=true"
import script from "./ProjectTree.vue?vue&type=script&lang=js"
export * from "./ProjectTree.vue?vue&type=script&lang=js"
import style0 from "./ProjectTree.vue?vue&type=style&index=0&id=fa4f2b68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4f2b68",
  null
  
)

export default component.exports